import * as React from 'react';
import * as main from '../../main.module.scss';
import * as revs from './style.module.scss';
import data from './data.json';
import { TextReviewsNew } from '../../../../TextReviewsNew';
export const RevsText = () => {
  return (
    <section className={revs.revs}>
      <div className="container">
        <h2 className={main.title}>Отзывы посетивших марафон</h2>
        <TextReviewsNew data={data} />
      </div>
    </section>
  );
};
